<template>
  <div class="flex flex-col rounded-xl bg-white p-4 sm:p-6 h-full">
    <div
      class="flex items-center justify-between flex-wrap md:flex-nowrap gap-2"
    >
      <div class="text-2xl text-gray-900 font-bold min-h-12 flex items-center">
        {{ title }}
      </div>
      <template v-if="$slots.buttons">
        <slot name="buttons" />
      </template>
      <template v-if="$slots.filters">
        <slot name="filters" />
      </template>
    </div>
    <div v-if="!loaded" class="flex justify-center py-10">
      <BaseSpinner />
    </div>
    <template v-else-if="!eventsList.length">
      <slot name="empty" />
    </template>
    <template v-else>
      <div
        class="py-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-10 gap-y-14"
      >
        <template v-for="event in eventsList" :key="event.id">
          <EventsCard :event="event" />
        </template>
      </div>
      <BaseObserve v-if="loaded && !allLoaded" @change="onObserverChange" />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Event } from '~/models/events'

interface PropsInterface {
  title: string
  eventsList: Event[]
  allLoaded?: boolean
  loading?: boolean
  loaded?: boolean
}

withDefaults(defineProps<PropsInterface>(), {
  allLoaded: false,
  loaded: false,
})

const emit = defineEmits(['next'])

function onObserverChange(visible: boolean) {
  visible && emit('next')
}
</script>
